import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-deeplinkpendingorder',
  templateUrl: './deeplinkpendingorder.component.html',
  styleUrls: ['./deeplinkpendingorder.component.scss']
})
export class DeeplinkpendingorderComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }
  onRenew(): void {

    setTimeout(() => {
      this.toMiniapp();
    }, 1000);
  }

  toMiniapp(): void {
    window.location.href = 'mbbank://?ad_dp=marketplaceapp&code=PHZTOMOTEK';
  }
}
